import React from 'react';

import ConclusionAddIcon from '@atlaskit/icon-lab/core/text-conclusion-add';

export const InsertAtOrBelowIcon = (): React.JSX.Element => <ConclusionAddIcon label="" spacing="spacious" />;
